import { ThunderDispatcherV3 } from '../../core/db-api-gen/types.js';
import { apiWithQuery } from '../../core/typed-api.js';
import { ModuleFE_BaseApi } from '../../modules/db-api-gen/ModuleFE_BaseApi.js';
import { ApiDef_AppConfig, DBDef_AppConfig } from '@nu-art/thunderstorm-shared';
import { BadImplementationException, cloneObj } from '@nu-art/ts-common';
export const dispatch_onAppConfigsUpdated = new ThunderDispatcherV3('__onAppConfigsUpdated');
export class ModuleFE_AppConfig_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_AppConfig, dispatch_onAppConfigsUpdated);
        this._v1 = {
            getConfigByKey: apiWithQuery(ApiDef_AppConfig._v1.getConfigByKey),
        };
    }
    async init() {
        super.init();
    }
    get(appConfigKey) {
        const config = this.cache.find(item => item.key === appConfigKey.key);
        return config?.data;
    }
    async set(appConfigKey, data) {
        let _config = cloneObj(this.cache.find(item => item.key === appConfigKey.key));
        if (!_config)
            _config = { key: appConfigKey.key };
        _config.data = data;
        await this.v1.upsert(_config).executeSync();
    }
    async delete(appConfigKey) {
        const config = this.cache.find(item => item.key === appConfigKey.key);
        if (!config)
            throw new BadImplementationException('Config of this key does not exist');
        await this.v1.delete(config).executeSync();
    }
}
export const ModuleFE_AppConfig = new ModuleFE_AppConfig_Class();
export class AppConfigKey_FE {
    key;
    constructor(key) {
        this.key = key;
    }
    get() {
        return ModuleFE_AppConfig.get(this);
    }
    async set(value) {
        // @ts-ignore
        await ModuleFE_AppConfig.set(this, value);
    }
    async delete() {
        await ModuleFE_AppConfig.delete(this);
    }
}
//# sourceMappingURL=ModuleFE_AppConfig.js.map